import { NavLink } from 'react-router-dom';
import { Home, FileText, Star, User } from 'lucide-react';
import { cn } from '@/lib/utils';

const navItems = [
  { to: '/contractor-portal/dashboard', label: 'Dashboard', icon: Home },
  { to: '/contractor-portal/documents', label: 'Documents', icon: FileText },
  { to: '/contractor-portal/ratings', label: 'Ratings', icon: Star },
  { to: '/contractor-portal/profile', label: 'Profile', icon: User },
];

export function PortalNavigation() {
  return (
    <nav className="border-b bg-card">
      <div className="flex space-x-1 px-6">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-2 px-4 py-3 text-sm font-medium transition-colors border-b-2',
                isActive
                  ? 'border-primary text-primary'
                  : 'border-transparent text-muted-foreground hover:text-foreground'
              )
            }
          >
            <item.icon className="h-4 w-4" />
            {item.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
